import { isInsideEditorPreviewFrame } from '@Core/lib/pageEditorPreview';

import { logger } from '@/lib/logger';

type SdkWarningMode = {
  isDevelopment: boolean;
  isEditorPreview: boolean;
};

type SdkWarningSinks = {
  telemetry: (message: string) => void;
  editorConsole: (message: string) => void;
};

const warnedFallbacks = new Set<string>();

export function caughtErrorDetail(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

export function resolveSdkWarningMode(
  isDevelopment: boolean = import.meta.env?.DEV === true
): SdkWarningMode {
  return {
    isDevelopment,
    isEditorPreview: isInsideEditorPreviewFrame()
  };
}

const defaultSinks: SdkWarningSinks = {
  telemetry: (message) => logger.warn(message),
  editorConsole: (message) => {
    // The logger omits console output in production, but SDK author warnings must remain visible there.
    // eslint-disable-next-line no-console
    console.warn(message);
  }
};

export function warnSdkUtilFallback(
  util: string,
  reason: string,
  mode: SdkWarningMode = resolveSdkWarningMode(),
  sinks: SdkWarningSinks = defaultSinks
): void {
  const message = `[Sdk.utils.${util}] ${reason}`;

  if (warnedFallbacks.has(message)) {
    return;
  }

  warnedFallbacks.add(message);
  sinks.telemetry(message);

  if (!mode.isDevelopment && mode.isEditorPreview) {
    sinks.editorConsole(message);
  }
}

export function resetSdkUtilWarningCache(): void {
  warnedFallbacks.clear();
}
